import { render, staticRenderFns } from "./SubconPayment.vue?vue&type=template&id=023b8029"
import script from "./SubconPayment.vue?vue&type=script&lang=js"
export * from "./SubconPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports